import { useState } from "react";
import { accountService, homeService } from "@miplatform/api";
import { HTTP_STATUSES, MAX_PAGE_SIZE } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { AccountType } from "@miplatform/types";

export const useCommunityVendorsTabViewModel = () => {
  const stateManager = useComponentState();
  const [supplierAccounts, setSupplierAccounts] = useState([]);
  const [vendors, setVendors] = useState([]);
  const isLoading = stateManager.isBusy();

  const getVendors = (communityId) => {
    stateManager.run(async () => {
      const response = await homeService.communityVendors.getAll({
        filters: [
          {
            communityId: { eq: { type: "guid", value: communityId } },
          },
        ],
      });
      if (response.status === HTTP_STATUSES.OK) {
        setVendors(response.data);
      }
    });
  };

  const getSupplierAccounts = () => {
    stateManager.run(async () => {
      const response = await accountService.accounts.getAll({
        filters: {
          accountType: AccountType.Supplier,
        },
        top: MAX_PAGE_SIZE,
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setSupplierAccounts(response.data);
      }
    });
  };

  const addVendor = async ({ data }) =>
    stateManager.run(async () => {
      const response = await homeService.communityVendors.create({
        data,
        toastMessageConfig: {
          success: {
            text: `Supplier added successfully.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }
      return null;
    });

  const deleteVendor = async ({ id, modifiedOn }) =>
    stateManager.run(async () => {
      const response = await homeService.communityVendors.delete({
        id,
        data: { modifiedOn },
        toastMessageConfig: {
          success: {
            text: `Supplier removed successfully.`,
          },
        },
      });
      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }
      return null;
    });

  return {
    isLoading,
    supplierAccounts,
    vendors,
    getSupplierAccounts,
    getVendors,
    addVendor,
    deleteVendor,
  };
};
